module.exports = __webpack_public_path__ + "static/media/google-drive-logo.40841483.svg";